import { EventGameOutcomeTypeEnum } from "../EventGameFixturesModel";
import { PredictionType } from "./PredictionType";

export default class EventGamePredictionFixturesModel<
  T extends EventGameOutcomeTypeEnum = EventGameOutcomeTypeEnum
> {
  public id: string = "";
  public predictionType: T;
  public prediction: PredictionType<T>;
  public correct: boolean | null = null;
  public points: number = 0;
}
